import React from "react";
import { motion } from "framer-motion";

import "../styles/PayrollShowcase.css";

import payrollImage from "../../../assets/payroll-module.png";

const PayrollShowcase = () => {
  return (

    <section className="payroll-showcase-section">

      {/* LEFT CONTENT */}

      <motion.div
        className="payroll-showcase-left"
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >

        <p className="payroll-mini-title">
          Salary Slip & Employee Document Management
        </p>

        <h2 className="payroll-main-title">
          Salary Slip & Employee <br />
          Document Management
        </h2>

        <p className="payroll-description">
          Manage employee salary document uploads,
          salary slips, appraisal letters, and miscellaneous
          documents, allowing management to upload files
          and employees to securely access them from
          their dashboard.
        </p>

        <div className="payroll-feature-list">

          <div className="payroll-feature-item">
            ✓ Salary Slip Upload & Distribution
          </div>

          <div className="payroll-feature-item">
            ✓ Appraisal Letter Management
          </div>

          <div className="payroll-feature-item">
            ✓ Miscellaneous Document Sharing
          </div>

          <div className="payroll-feature-item">
            ✓ Employee Dashboard Document Access
          </div>
        </div>

      </motion.div>

      {/* RIGHT IMAGE */}

      <motion.div
        className="payroll-showcase-right"
        initial={{ opacity: 0, x: 80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >

        <img
          src={payrollImage}
          alt="payroll"
          className="payroll-showcase-image"
          style={{ imageRendering: "-webkit-optimize-contrast" }}
        />

      </motion.div>

    </section>

  );
};

export default PayrollShowcase;